import { Callback } from '@csp/csp-common-model';
import { CspPodConfigs, CspPodName, CspPodUrl } from './model/CspPodConfigs';
import { CspConfigService } from './service/CspConfigService';

export const cspBaseUrl = (): string => CspConfigService.getCspBaseConfig().baseUrl;
export const cspConfig = (): CspPodConfigs => CspConfigService.getCspPodConfigs();

const baseUrlIsNotSet = (url: string | undefined): boolean => !url && url !== '';

const getBaseUrlOf =
  (podName: CspPodName): Callback<CspPodUrl> =>
  (): CspPodUrl => {
    const url = CspConfigService.getCspPodConfig(podName).baseUrl;
    if (baseUrlIsNotSet(url)) {
      throw new Error(`The base url for ${podName} is not set`);
    }
    return url!;
  };

export const cspPodUrl = getBaseUrlOf('csppod');
export const accountPodUrl = getBaseUrlOf('accountpod');
export const patientMgmtApiUrl = getBaseUrlOf('patient-mgmt-api');
export const devicesApiUrl = getBaseUrlOf('devices-api-be');
export const studyApiUrl = getBaseUrlOf('study-api-be');
